import { render, staticRenderFns } from "./OrderReportDetailDispatch.vue?vue&type=template&id=f246d7f8"
import script from "./OrderReportDetailDispatch.vue?vue&type=script&lang=js"
export * from "./OrderReportDetailDispatch.vue?vue&type=script&lang=js"
import style0 from "./OrderReportDetailDispatch.vue?vue&type=style&index=0&id=f246d7f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports